/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  PaymentOptions.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			    : Jul 29, 2019
*
* @Version      : Version 1.0

 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-985: Shipping & Billing - PO switching logic
 *
 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-986: PO screen UI validation.
 *
 * By            : Avanthi G
 * On            : Aug 12, 2019
 * Description   : ASDS-956: Added appendLeadingZeroes() function
 *
 * By            : sivateja.p
 * On            : Aug 20, 2019
 * Description   : ASDS-957: Implemetented External CSS for Paymetric screen
 *
 * By: Madhu Gali
 * On: Sep 09, 2019
 * Description: ASDS-1199: User Navigation - Payment Method Issues - Active tab validation
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 10, 2019
 * Description   : ASDS-1200
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Sep 19, 2019
 * Description   : Added "What is CVV" - ASDS-1285
 *
 * By            : E807238
 * On            : Nov 05, 2019
 * Description   : ASDS-1679: PO date, Upload PO document as optional fields
 *
 * By            : E807958
 * On            : 25 Nov 2019
 * Description   : ASDS-1676
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - Add validation for PO Date field to prevent future date(manual entry)
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 06,2020
 * Description   : updated code as per ASDS-1764.
 *
 * By            : H224423
 * On            : Jan 23, 2019
 * Description   : Po Tab issue fixes.
 *
 * By            : H224423
 * On            : Jan 23, 2019
 * Description   : ASDS-2083 - PO Field error message UI changes
 *
 * By            : Deepthi Bachu - E844276
 * On            : 09 Apr, 2020
 * Description   : Added Payterm condition
 *
 * By            : H422335
 * On            : 26 Nov, 2020
 * Description   : ASDS-4086 - PO Date field improvement
******************************************************************************/

import * as React from "react";
import {
  Grid,
  Tab,
  Button,
  Input,
  InputLabel,
  DatePicker
} from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./ShippingAndBilling.css";
import "@scuf/styles/variables.scss";
import PaymetricScreen from './../Payment/paymetricScreen';
import { logInfo } from '../../../utils/console-utility';

interface PaymentOptionsStateI {
  poFilepath: string,
  poDoc: any,
}

interface PaymentOptionsPropsI {
  validatePOTabFields: Function,
  errors: {},
  poFields: {},
  payTerm: string,
  updateActivePaymentTab: Function,
}

class PaymentOptions extends React.PureComponent<PaymentOptionsPropsI, PaymentOptionsStateI>{
  setPONumber: (value: string) => void;
  setPODate: (date: Date) => void;
  setPODateTextBox: (val: string, dateerror:any) => void;
  setPODocument: (value: any, error: any) => void;

  constructor(props: PaymentOptionsPropsI) {
    super(props);
    this.state = {
      poFilepath: '',
      poDoc: '',
    };

    this.setPONumber = this.props.validatePOTabFields("poNumber");
    this.setPODate = this.props.validatePOTabFields("poDate");
    this.setPODateTextBox = this.props.validatePOTabFields("poDate");
    this.setPODocument = this.props.validatePOTabFields("poDoc");
    this.handleChooseFileClick = this.handleChooseFileClick.bind(this)
    this.updateFileName = this.updateFileName.bind(this);
  }

  handleChooseFileClick() {
    let file = document.getElementById("file");
    this.setState({
      poFilepath: '',
      poDoc: {},
    }, () => {
      this.setPODocument('', '');
      if (file) {
        file.click();
      }
    })
  }

  updateFileName() {
    let input: any = document.getElementById("file");
    if (input) {
      let selectedFile = input.files;
      if (selectedFile.length !== 0) {
        const ext = selectedFile[0].name.split('.').pop();
        let errormsg = '';
        if (ext && ext.toLowerCase() !== 'pdf') {
          errormsg = 'PDF Format Only';
        }
        this.setState({
          poFilepath: selectedFile[0].name,
          poDoc: selectedFile[0]
        }, () => {
          this.setPODocument(selectedFile[0], errormsg);
        });
      }
    }
  }
  render() {
    let cbdStatus: boolean = (this.props.payTerm === 'C035' || this.props.payTerm === 'C015' || this.props.payTerm === '');
    return (
      <React.Fragment>
        {/*ASDS-985*/}
        {(cbdStatus) &&
          <Tab defaultActiveIndex={0} onTabChange={(activeIndex) => (this.props.updateActivePaymentTab(activeIndex))}>
            {/*******************credit card tab pane starts ere******************/}
            <Tab.Pane title="CREDIT CARD" className="tabPaneStyles" >
              <PaymetricScreen />
            </Tab.Pane>
            {/*******************credit card tab pane ends here******************/}
          </Tab>
        }
        {!cbdStatus &&

          <Tab defaultActiveIndex={0} onTabChange={(activeIndex) => (this.props.updateActivePaymentTab(activeIndex))}>
            {/*******************credit card tab pane starts ere******************/}
            <Tab.Pane title="CREDIT CARD" className="tabPaneStyles">
              <PaymetricScreen />
            </Tab.Pane>
            {/*******************credit card tab pane ends here******************/}
            {/*******************PO tab pane Starts here******************/}
           <Tab.Pane title="PO (Purchase Order)">
              <Grid className="fullwidthRow">
                <Grid.Row className="fullwidthRow">
                  <Grid.Column width={12} className="fullwidthRow">
                    <Input
                      className="input-example"
                      label="PO Number"
                      placeholder="Enter Production Order Number"
                      indicator="required"
                      value={this.props.poFields['poNumber']}
                      error={this.props.errors["poNumber"]}
                      onChange={this.setPONumber}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="fullwidthRow">
                  <Grid.Column width={12} className="fullwidthRow">
                    <DatePicker
                      type="date"
                      label="PO Date"
                      placeholder="MM/DD/YYYY"
                      className="PO-datepicker"
                      disableFuture={true}
                      showYearSelector={true}
                      indicator="required"
                      value={this.props.poFields['poDate']}
                      error={this.props.errors['poDate']}
                      onChange={(date) => this.setPODate(date)}
                      onTextChange={(value, dateerror) => { this.setPODateTextBox(value, dateerror); }}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="fullwidthRow">
                  <Grid.Column width={12} className="fullwidthRow">
                    <InputLabel
                      label="Upload PO Document"
                      indicator="required"
                    />
                  </Grid.Column>
                  <Grid.Column
                    width={12}
                    className="fullwidthRow uploadGroup"
                  >
                    <Input
                      value={this.state.poFilepath}
                      placeholder="Upload PDF Document"
                      error={this.props.errors["poDoc"]}
                      disabled={true}
                    />{" "}
                    <input type="file" id="file" style={{ "display": "none" }} accept={".pdf"}
                      onChange={this.updateFileName} />
                    <Button
                      className="browse-file-btn"
                      type="secondary"
                      content="Browse File"
                      onClick={this.handleChooseFileClick}
                      id="chooseFile"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
            {/*******************PO tab pane ends here******************/}
          </Tab>
  }
      </React.Fragment>
    );
  }
}

/**
 * ASDS-986
 * This method validates the PO fields.
 * @param PONumber
 * @returns {string}
 */
export function validatePONumber(PONumber: any) {

  let errorMsg = "";

  if (!PONumber) {
    errorMsg = "Please provide PO number";
  } else {
    if (!PONumber.match(/^([A-Za-z0-9\-]+?)*$/i)) {
      errorMsg = "PO Number must contain only letters, digits or the character(-)";
    }
  }
  return errorMsg;
}

export function validatePODate(poDate: string) {
  let errorMsg = "";
  logInfo("Inside ValidatePODate", poDate)
  let re = "^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$";

  if (!poDate) {
    errorMsg = "Please select a date";
  }
  else if (!poDate.match(re)) {
    errorMsg = "Provide PO Date in mm/dd/yyyy format"

  }
  return errorMsg;
}

export function GetFormattedDate(date) {
  if (!date) {
    return '';
  }
  var todayTime = new Date(date);
  var month = (todayTime.getMonth() + 1);
  var day = (todayTime.getDate());
  var year = (todayTime.getFullYear());
  return appendLeadingZeroes(month) + "/" + appendLeadingZeroes(day) + "/" + year;
}

/**
 * ASDS-956
 * This method Appends LeadingZeros to the day and month of Date.
 * @param day or month
 * @returns {string}
 */
export function appendLeadingZeroes(n) {
  if (n <= 9) {
    return "0" + n;
  }
  return n
}

export function validatePODoc(poDoc: File) {
  let ALLOWED_FILE_SIZE = 5242890;
  let errorMsg = "";
  if(poDoc === undefined){
    errorMsg = "Please select PO document";
  }else{
    const poDocPath = poDoc.name;
    if (!poDocPath) {
      errorMsg = "Please select PO document";
    } else {
      if (!poDocPath.toLowerCase().endsWith('.pdf')) {
        errorMsg = "Please select only PDF document";
      }
      if (poDoc) {
        if (poDoc.size > ALLOWED_FILE_SIZE) {
          logInfo("poDoc.size ", poDoc.size);
          errorMsg = "File size can not be greater than 5MB. Please upload again."
        }
      }
    }
  }
  logInfo(errorMsg)
  return errorMsg;
}


export default PaymentOptions;